
const columnNames = {
    Country: 'Country',
    Platform: 'pl_type',
    Placement: 'Placement',
    PlacementId: 'placement_id',
    Clicks: 'Clicks',
    Installs: 'Installs',
    Impressions: 'Impressions',
    CTR: 'CTR',
    CR: 'CR',
    Earning: 'Earning',
    eCPM: 'eCPM',
    Apps: 'Apps',
    pba_number: 'pba_number',
    pba_id: 'pba_id',
    date: 'dateUnix',
    country_code: 'country_code',
    Advertiser: 'Advertiser',
    advertiserId: 'adveriser_id',
    campaignsId: 'campaignsId',
    campaigns: 'campaigns',
    store_data: 'store_data',
    adveriserAppId: 'adveriser_id',
    advertiser_pb_number: 'pb_number'
}

export default columnNames;



// WEBPACK FOOTER //
// ./src/components/Revenue/columnNames.js